const REASON_INACTIVE = 'inactive'
const REASON_SUSPENDED = 'suspended'
const REASON_NOT_PUBLISHED = 'not-published'

const originalErrorsToReason = {
  ApplicationInactiveError: REASON_INACTIVE,
  ApplicationSuspendedError: REASON_SUSPENDED,
  ApplicationNotPublishedError: REASON_NOT_PUBLISHED
}

class ForbiddenError extends Error {
  constructor(message, originalErrorName) {
    super()
    this.name = 'ForbiddenError'
    this.message = message || 'Sorry, there was a technical issue'
    this.reason = originalErrorsToReason[originalErrorName]
  }
}

ForbiddenError.Reasons = { REASON_INACTIVE, REASON_SUSPENDED, REASON_NOT_PUBLISHED }

export default ForbiddenError
